import React from "react";

import "./styles.scss";

export default function Loading() {
  return (
    <div id="preloader">
      <div id="loader"></div>
    </div>
  );
}
